import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Col, Row } from 'antd';
import { AppRouteKey } from '../../core/utilities/router';
import useRouterWithLang from '../../core/hooks/useRouterWithLang';
import axios from 'axios';

const approveHash = async (hash: string): Promise<void> => {
  return await axios.post(
    `${process.env.REACT_APP_BASE_URL}/auth/consume-link-hash/register/${hash}`
  );
};

const declineHash = async (hash: string): Promise<void> => {
  return await axios.post(
    `${process.env.REACT_APP_BASE_URL}/auth/consume-link-hash/register/deny/${hash}`
  );
};

const RegisterActivationCard = () => {
  const navigate = useNavigate();
  const { provideUrl } = useRouterWithLang();
  const [params] = useSearchParams();
  const uyeAd = params.get('uyeAd') || '';
  const uyeSoyad = params.get('uyeSoyad') || '';
  const uyeEmail = params.get('uyeEmail') || '';
  const uyeTelefon = params.get('uyeTelefon') || '';
  const uyePlate = params.get('uyePlate') || '';
  const uyeId = params.get('uyeId') || '';
  const hash = params.get('hash') || '';
  return (
    <div
      style={{
        maxWidth: 600,
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: 8,
        padding: 20,
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        fontFamily: 'Arial, Helvetica, sans-serif',
        color: '#000',
      }}
    >
      <h1
        style={{
          fontSize: 20,
          fontWeight: 400,
          lineHeight: 1.4,
          margin: '0 0 10px',
        }}
      >
        Sayın Filo Yöneticisi,
      </h1>

      <p style={{ margin: '0 0 16px', lineHeight: 1.5, fontSize: 14 }}>
        Aşağıda bilgileri yer alan kişi, Hedefnet platformuna üye olmuştur. Bu
        kaydın sizin bilginiz dahilinde gerçekleştirildiğini teyit edebilmek
        adına, lütfen aşağıdaki bilgileri kontrol ederek onaylayınız veya
        reddediniz.
      </p>

      <div
        style={{
          backgroundColor: '#f7f8f9',
          borderRadius: 8,
          padding: 16,
          fontSize: 14,
          marginBottom: 20,
        }}
      >
        <div style={{ display: 'flex', marginBottom: 8 }}>
          <div style={{ width: '40%', fontWeight: 600 }}>Ad Soyad:</div>
          <div>
            {uyeAd} {uyeSoyad}
          </div>
        </div>
        <div style={{ display: 'flex', marginBottom: 8 }}>
          <div style={{ width: '40%', fontWeight: 600 }}>E-posta Adresi:</div>
          <div>{uyeEmail}</div>
        </div>
        <div style={{ display: 'flex', marginBottom: 8 }}>
          <div style={{ width: '40%', fontWeight: 600 }}>Telefon Numarası:</div>
          <div>{uyeTelefon}</div>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '40%', fontWeight: 600 }}>Plaka:</div>
          <div>{uyePlate}</div>
        </div>
      </div>

      <Row justify="center" gutter={16}>
        <Col>
          <Button
            onClick={() => {
              declineHash(hash).finally(() => {
                navigate(
                  provideUrl(AppRouteKey.ACTIVATION_FAIL) +
                    `?userId=${uyeId}&userNameSurname=${uyeAd + ' ' + uyeSoyad}`
                );
              });
            }}
            type={'default'}
          >
            Üyeliği Reddet
          </Button>
        </Col>
        <Col>
          <Button
            onClick={() => {
              approveHash(hash)
                .then(() => {
                  navigate(
                    provideUrl(AppRouteKey.ACTIVATION_SUCCESS) +
                      `?userId=${uyeId}&userNameSurname=${
                        uyeAd + ' ' + uyeSoyad
                      }`
                  );
                })
                .catch((err) => {
                  navigate(
                    provideUrl(AppRouteKey.ACTIVATION_FAIL) +
                      `?userId=${uyeId}&userNameSurname=${
                        uyeAd + ' ' + uyeSoyad
                      }`
                  );
                });
            }}
            type={'primary'}
          >
            Üyeliği Onayla
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default RegisterActivationCard;
